// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2Zr-v","inputDescription":"styles_inputDescription__1WOS2"};